import React from "react";
import {
  Dialog,
  DialogActions,
  DialogContent,
  Button,
  Typography,
  Box,
  Grid,
  Divider,
  Link,
  Card,
  CardContent,
  Chip
} from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import DescriptionIcon from "@mui/icons-material/Description";
import NumbersIcon from "@mui/icons-material/Numbers";
import AttachMoneyIcon from "@mui/icons-material/AttachMoney";
import SecurityIcon from "@mui/icons-material/Security";
import LinkIcon from "@mui/icons-material/Link";
import DirectionsCarIcon from "@mui/icons-material/DirectionsCar";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";

// Reusable Info display component
const InfoItem = ({ icon, label, value }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      marginBottom: 1.5,
      backgroundColor: "#f4f6f9",
      padding: 1.5,
      borderRadius: "8px",
    }}
  >
    {icon && <Box sx={{ marginRight: 1, color: "#152d51" }}>{icon}</Box>}
    <Typography variant="subtitle1">
      <strong>{label}:</strong> {value}
    </Typography>
  </Box>
);

const DetalleDocumentacion = ({ selectedDocumentacion, handleDetailClose }) => {
  if (!selectedDocumentacion) {
    return <Typography variant="body1">Cargando documentación...</Typography>;
  }

  const {
    tipo,
    numero,
    fecha_emision,
    fecha_vencimiento,
    observaciones,
    archivo,
    suma_asegurada,
    tipo_cobertura,
    vehiculo_nombre,
    esta_vencido,
  } = selectedDocumentacion;

  return (
    <Dialog open={!!selectedDocumentacion} onClose={handleDetailClose} fullWidth maxWidth="md">
      <DialogContent dividers sx={{ padding: "20px", backgroundColor: "#f4f6f9" }}>
        <Card sx={{ boxShadow: 3, borderRadius: "8px", padding: 2 }}>
          <CardContent>
            <Typography
              variant="h6"
              sx={{
                fontWeight: "bold",
                color: "#152d51",
                display: "flex",
                alignItems: "center",
                marginBottom: 2,
              }}
            >
              <DescriptionIcon sx={{ marginRight: 1 }} />
              <strong>Detalles de Documentación</strong>
            </Typography>

            <Divider sx={{ my: 2 }} />

            {/* Expiration Alert */}
            {esta_vencido && (
              <Chip
                label="Documento vencido"
                color="error"
                icon={<ErrorOutlineIcon />}
                sx={{ mb: 2 }}
              />
            )}

            <Grid container spacing={2}>
              {/* Left Column */}
              <Grid item xs={12} sm={6}>
                <InfoItem icon={<DescriptionIcon />} label="Tipo" value={tipo} />
                {numero && <InfoItem icon={<NumbersIcon />} label="Número" value={numero} />}
                {suma_asegurada && (
                  <InfoItem icon={<AttachMoneyIcon />} label="Suma Asegurada" value={`$${suma_asegurada}`} />
                )}
                {tipo_cobertura && (
                  <InfoItem icon={<SecurityIcon />} label="Tipo de Cobertura" value={tipo_cobertura} />
                )}
              </Grid>

              {/* Right Column */}
              <Grid item xs={12} sm={6}>
                <InfoItem icon={<CalendarTodayIcon />} label="Fecha de Emisión" value={fecha_emision || "-"} />
                <InfoItem icon={<CalendarTodayIcon />} label="Fecha de Vencimiento" value={fecha_vencimiento || "-"} />
                {archivo && (
                  <InfoItem
                    icon={<LinkIcon />}
                    label="Archivo"
                    value={
                      <Link href={archivo} target="_blank" rel="noopener noreferrer">
                        Descargar archivo
                      </Link>
                    }
                  />
                )}
                <InfoItem icon={<DirectionsCarIcon />} label="Vehículo" value={vehiculo_nombre} />
                {observaciones && <InfoItem icon={<DescriptionIcon />} label="Observaciones" value={observaciones} />}
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </DialogContent>

      <DialogActions sx={{ padding: "16px", backgroundColor: "#f4f6f9" }}>
        <Button onClick={handleDetailClose} variant="contained" sx={{ backgroundColor: "#152d51" }} fullWidth>
          Cerrar
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DetalleDocumentacion;
